import { ClientWebEmbeddingMessageType } from '@youhelp-ru/common/clientWebEmbedding';
import React from 'react';
import { introCareerIdSelector, introCatalogTypeSelector } from '@cp/entities/intro';
import { useSelector } from 'react-redux';
import { IEmbeddingMessagesTriggerProps } from '../types';

export const useIntroMessageTriggers = ({ isRecipientReady, isInited, postMessage }: IEmbeddingMessagesTriggerProps) => {
  const introCatalogType = useSelector(introCatalogTypeSelector);
  const storedIntroCatalogType = React.useRef(introCatalogType);
  const introCareerId = useSelector(introCareerIdSelector);
  const storedIntroCareerId = React.useRef(introCareerId);

  React.useEffect(() => {
    if (!isInited || !isRecipientReady) {
      return;
    }

    if (introCatalogType && introCatalogType !== storedIntroCatalogType.current) {
      postMessage({ type: ClientWebEmbeddingMessageType.IntroCatalogTypeChanged, catalogType: introCatalogType });
      storedIntroCatalogType.current = introCatalogType;
    }

    if (introCareerId && introCareerId !== storedIntroCareerId.current) {
      postMessage({ type: ClientWebEmbeddingMessageType.IntroCareerIdChanged, careerId: introCareerId });
      storedIntroCareerId.current = introCareerId;
    }
  }, [isInited, isRecipientReady, introCatalogType, introCareerId, postMessage]);
};
